import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import About from '../components/sections/About';
import AppShowcase from '../components/sections/AppShowcase';
import Board from '../components/sections/Board';
import ContactSection from '../components/sections/ContactSection';
import EventsGallery from '../components/sections/EventsGallery';
import Hero from '../components/sections/Hero';
import Municipalities from '../components/sections/Municipalities';
import Sponsors from '../components/sections/Sponsors';

export function HomePage() {
  return (
    <div className="home-page font-sans text-slate-800 antialiased selection:bg-brand-yellow selection:text-brand-darkGreen">
      <Navbar />
      <main>
        <Hero />
        <Municipalities />
        <About />

        <div id="diretoria">
          <Board />
        </div>

        <AppShowcase />
        <EventsGallery />
        <ContactSection />
        <Sponsors />
      </main>
      <Footer />
    </div>
  );
}
